/* eslint-disable */
import { withStyles, Chip } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TimelapseIcon from '@material-ui/icons/Timelapse';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { Divider } from '@material-ui/core';
import Icons from '../Icons/Icons.component';
import ReceiptIcon from '@material-ui/icons/Receipt';
import round from 'lodash/round';
import orderBy from 'lodash/orderBy';
import cn from 'classnames';
import React from 'react';
import i18nLocaleSelector from '../../State/Store/I18n/Selectors/I18nLocale.selector';
import dateOnly from '../../Support/DateTime/DateOnly/DateTimeDateOnly.support';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { shouldShowPlusLoad } from 'Components/OrderDetailsHeader/parts/utils/should-show-plus-load';
import {
  UI_DOCKET_DETAILS_DIALOG_OPEN,
  UI_DELIVERED_EXPANSION_PANEL_COLLAPSED,
  UI_DELIVERED_EXPANSION_PANEL_EXPANDED,
  UI_IN_TRANSIT_EXPANSION_PANEL_COLLAPSED,
  UI_IN_TRANSIT_EXPANSION_PANEL_EXPANDED,
  UI_SCHEDULED_EXPANSION_PANEL_COLLAPSED,
  UI_SCHEDULED_EXPANSION_PANEL_EXPANDED,
  UI_SCHEDULED_EXPANSION_PANEL_DOCKET_OPEN,
} from '../../State/Store/UI/UI.types';
import { APPLIED, SUBMITTED, ORDER_API_DATE_FORMAT } from '../../Constants/Order/Order.constants';
import toDisplayUnit from '../../Support/Converters/ToDisplayUnit/ConvertersToDisplayUnit.support';
import Colors from 'Support/Theme/Colors/Colors';
import generateHash from '../../Support/Generators/GenerateHash/GeneratorsGenerateHash.support';
import isNumber from '../../Support/Is/Number/IsNumber.support';
import DeliveryDocketModal from '../DeliveryDocket/DeliveryDocketModal.component';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import TrucksExpandableSectionPropTypes from './TrucksExpandableSection.component.props';
import TrucksExpandableSectionStyles from './TrucksExpandableSection.component.styles';
import envGet from '../../Support/Env/Get/EnvGet.support';
const REACT_APP_BORAL_FEATURE_TOGGLE_DOCKETS = envGet({ key: `REACT_APP_BORAL_FEATURE_TOGGLE_DOCKETS` }) === `true`;

/**
 * TrucksExpandableSectionComponent
 * @export
 * @class TrucksExpandableSectionComponent
 * @extends {React.Component<TrucksExpandableSectionComponentComposedProps, TrucksExpandableSectionComponentState>}
 */
export class TrucksExpandableSectionComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<TrucksExpandableSectionComponentProps>}
   * @memberof TrucksExpandableSectionComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`TrucksExpandableSectionComponent`}
   * @memberof TrucksExpandableSectionComponent
   */
  static displayName = `TrucksExpandableSectionComponent`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof TrucksExpandableSectionComponent
   */
  static propTypes = TrucksExpandableSectionPropTypes;

  /**
   * Data specific to the `<TrucksExpandableSectionComponent />` instance
   * @type {TrucksExpandableSectionComponentState}
   * @memberof TrucksExpandableSectionComponent
   */
  state = {
    deliveredExpanded: false,
    scheduledExpanded: false,
    inTransitExpanded: false,
  };

  /**
   * Returns the unit of measure
   * @returns {string} The unit of measure
   * @memberof TrucksExpandableSectionComponent
   */
  getUnitOfMeasure = () => {
    const { currentOrder } = this.props;
    const { details } = currentOrder;
    const { qty } = details || {};
    const { uom } = qty || {};
    return toDisplayUnit(uom);
  };

  /**
   * Renders the expand icon
   * @param {boolean} expanded Is arrow for expanded component
   * @returns {React.Component} component
   * @memberof TrucksExpandableSectionComponent
   */
  renderExpandIcon = (expanded) => {
    const { classes } = this.props;
    if (expanded) {
      return <ArrowDropUpIcon className={classes.expandIcon} />;
    }
    return <ArrowDropDownIcon className={classes.expandIcon} />;
  };

  /**
   * Returns formatted load quantity string
   * @param {number} loadQty Quantity
   * @returns {string} formatted quantity
   * @memberof TrucksExpandableSectionComponent
   */
  formatQuantity = (loadQty) => `${round(loadQty, 1).toFixed(1)} ${this.getUnitOfMeasure()}`;

  /**
   * Renders the delivery load item
   * @param {number} startFrom Number to start rendering with
   * @returns {function} function
   * @memberof TrucksExpandableSectionComponent
   */
  renderScheduledLoad = (startFrom) => (load, i) => {
    const {
      classes,
      locale: { lang },
    } = this.props;
    const {
      loadQty,
      reviewedOnJobTime,
      truck: { actualLoadTime, code },
    } = load;
    const isLoading = actualLoadTime.trim().length > 0;
    const isTicketed = code.trim().length > 0;
    const options = { hour: `numeric`, minute: `numeric`, timeZone: `UTC` };
    const etaTime = isNumber(+reviewedOnJobTime) ? new Intl.DateTimeFormat(lang, options).format(new Date(+reviewedOnJobTime)).toUpperCase() : `-`;
    return (
      <div key={generateHash(load)}>
        <Grid container justify="flex-start" alignItems="center" className={cn(classes.flexWrapNowrap)}>
          <Grid item>
            <Typography variant="body1">{startFrom + i}</Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" className={cn(classes.borderLeft)}>
              {this.formatQuantity(loadQty)}
            </Typography>
          </Grid>
          <Grid item>
            {isLoading && (
              <Typography variant="overline" className={cn(classes.borderLeft)}>
                <span className={classes.loading}>LOADING</span>
              </Typography>
            )}
          </Grid>
        </Grid>

        <Grid container spacing={1} alignItems="center" className={cn(classes.flexWrapNowrap, classes.scheduledLoad)}>
          <Grid item>
            <Chip icon={<TimelapseIcon className={classes.timeLapseIcon} />} className={classes.scheduled} label={etaTime} />
          </Grid>
          <Grid item>
            {isTicketed && (
              <Chip variant="outlined" className={classes.chipTruck} icon={<Icons color={Colors.zambezi[600]} size="18" type="TRUCK" />} label={code} />
            )}
          </Grid>
        </Grid>
      </div>
    );
  };

  /**
   * Renders the delivery load item
   * @param {number} startFrom Number to start rendering with
   * @returns {function} function
   * @memberof TrucksExpandableSectionComponent
   */
  renderDeliveredLoad = (startFrom) => (load, i) => {
    const { classes } = this.props;
    const {
      loadQty,
      ticketCode,
      truck: { code },
    } = load;

    return (
      <div key={generateHash(load)} onClick={() => this.openDocketDetails(ticketCode)} className={classes.cursorPointer}>
        <Grid container justify="flex-start" alignItems="center" className={cn(classes.flexWrapNowrap)}>
          <Grid item>
            <Typography variant="body1">{startFrom + i}</Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" className={cn(classes.borderLeft)}>
              {this.formatQuantity(loadQty)}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="caption" className={cn(classes.borderLeft,classes.docketWithIcon)}>
              <ReceiptIcon className={cn(classes.docketIcon)}/>{ticketCode}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={1} alignItems="center" className={cn(classes.flexWrapNowrap, classes.marginBottom1unit, classes.marginTop1unit)}>
          <Grid item>
            <Chip variant="outlined" className={classes.chipTruck} icon={<Icons color={Colors.zambezi[600]} size="18" type="TRUCK" />} label={code} />
          </Grid>
        </Grid>
      </div>
    );
  };

  /**
   * Returns the ETA
   * @param {Object} load The load
   * @returns {string} The ETA
   * @memberof TrucksExpandableSectionComponent
   */
  getEta = (load) => {
    const {
      truck: { eta },
    } = load;
    if (eta.trim().length > 0) {
      return eta.trim();
    }
    return null;
  };

  /**
   * Renders the delivery load item
   * @param {number} startFrom Number to start rendering with
   * @returns {function} function
   * @memberof TrucksExpandableSectionComponent
   */
  renderInTransitLoad = (startFrom) => (load, i) => {
    const {
      classes,
      onOpenMap,
      locale: { lang },
    } = this.props;
    const {
      loadQty,
      truck: { code },
    } = load;
    const options = { hour: `numeric`, minute: `numeric`, timeZone: `UTC` };

    const eta = this.getEta(load);
    const etaTime = eta && isNumber(+eta) ? new Intl.DateTimeFormat(lang, options).format(new Date(+eta)) : `-`;

    return (
      <div key={generateHash(load)}>
        <Grid container justify="flex-start" alignItems="center" className={cn(classes.flexWrapNowrap)}>
          <Grid item>
            <Typography variant="body1">{startFrom + i}</Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" className={cn(classes.borderLeft)}>
              {this.formatQuantity(loadQty)}
            </Typography>
          </Grid>
          <Grid item>{/* TODO icons */}</Grid>
        </Grid>
        <Grid container spacing={1} alignItems="center" className={cn(classes.flexWrapNowrap, classes.marginBottom1unit)}>
          <Grid item>
            <Chip onClick={onOpenMap} icon={<TimelapseIcon className={classes.timeLapseIcon} />} className={classes.inTransit} label={<span className={classes.textDecorationUnderline}>{etaTime}</span>} />
          </Grid>
          <Grid item>
            <Chip  onClick={onOpenMap} variant="outlined" className={classes.chipTruck} icon={<Icons color={Colors.zambezi[600]} size="18" type="TRUCK" />} label={<span className={classes.textDecorationUnderline}>{code}</span>} />
          </Grid>
        </Grid>
      </div>
    );
  };

  /**
   * Renders Plus Load
   * @returns {React.Component} component
   * @memberof TrucksExpandableSectionComponent
   */
  renderPlusLoad = () => {
    const { currentOrder, classes } = this.props;
    const showPlusLoad = shouldShowPlusLoad(currentOrder);
    if (!showPlusLoad || !currentOrder.details) {
      return null;
    }
    const { status, qty } = currentOrder.details.plusLoadDetails;
    const showSubmitted = status === SUBMITTED;
    const showApplied = status === APPLIED;

    return (
      <Grid container spacing={2} justify="flex-start" alignItems="center">
        <Grid item xs={12}>
          <Typography variant="subtitle2" className={classes.dotPlusLoad}>
            Plus Load
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {showSubmitted && <Typography variant="body1">{qty} m³ submitted</Typography>}
          {showApplied && <Typography variant="body1">{qty} m³ included</Typography>}
        </Grid>
      </Grid>
    );
  };

  /**
   * Opens modal
   * @param {string} ticketCode Ticket code for the docket
   * @returns {void} void
   * @memberof OrderConcreteDeliveriesInTransitSectionComponent
   */
  openDocketDetails = async (ticketCode) => {
    if (!REACT_APP_BORAL_FEATURE_TOGGLE_DOCKETS) {
      return;
    }
    const { userInfo, actions, currentOrder } = this.props;
    const { summary } = currentOrder || {};
    if (!summary) {
      return;
    }
    const { startTime, orderLine } = summary;
    const date = dateOnly(startTime, ORDER_API_DATE_FORMAT);
    const orderCode = summary.orderCode.trim();

    actions.uiTriggered({
      type: UI_SCHEDULED_EXPANSION_PANEL_DOCKET_OPEN,
    });

    this.setState({ docketId: ticketCode });
  };

  /**
   * Closes modal
   * @returns {void} void
   * @memberof TrucksExpandableSectionComponent
   */
  closeDocketDetails = () => {
    this.setState({ docket: null, docketId: null });
  };

  /**
   * Renders expandable panel section
   * @param {object} details Details required to render panel
   * @returns {React.Component} component
   * @memberof TrucksExpandableSectionComponent
   */
  renderPanel = ({ loads, summary, onExpansionPanelChange, expanded, label }) => {
    const { classes } = this.props;
    return (
      <div>
        <ExpansionPanel elevation={0} disabled={!loads.length} defaultExpanded={false} square classes={{root: classes.expansionPanel, disabled: classes.expansionPanel }}  onChange={onExpansionPanelChange}>
          <ExpansionPanelSummary classes={{ root: cn(classes.expansionPanelSummary), content: classes.expansionPanelSummary, expanded: classes.expansionPanelSummary, disabled: classes.expansionPanelSummary }}>
          <div >
            <Grid alignItems="center" className={classes.flexWrapNowrap} container>
              <Grid item>{label}</Grid>
              <Grid item>{loads.length ? this.renderExpandIcon(expanded) : ``}</Grid>
              <Grid item className={cn(classes.textAlignRight, classes.flexGrow1, classes.overflowHidden)}>
                <Typography
                  variant="subtitle2"
                  className={cn(classes.summary, classes.overflowHidden, classes.textOverflowEllipsis, classes.whiteSpaceNowrap, classes.fontWeight500)}
                >
                  {summary}
                </Typography>
              </Grid>
            </Grid>
          </div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.noPadding}>
            <div className={classes.detailsContainer}>{loads}</div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    );
  };

  /**
   * Reports to analytics and flips expanded state
   * @returns {void} void
   * @memberof TrucksExpandableSectionComponent
   */
  onExpansionScheduledPanelChange = () => {
    const { actions } = this.props;
    const { scheduledExpanded } = this.state;
    const type = !scheduledExpanded ? UI_SCHEDULED_EXPANSION_PANEL_EXPANDED : UI_SCHEDULED_EXPANSION_PANEL_COLLAPSED;
    actions.uiTriggered({
      type,
    });
    this.setState({
      scheduledExpanded: !scheduledExpanded,
    });
  };

  /**
   * Reports to analytics and flips expanded state
   * @returns {void} void
   * @memberof TrucksExpandableSectionComponent
   */
  onExpansionDeliveredPanelChange = () => {
    const { actions } = this.props;
    const { deliveredExpanded } = this.state;
    const type = !deliveredExpanded ? UI_DELIVERED_EXPANSION_PANEL_EXPANDED : UI_DELIVERED_EXPANSION_PANEL_COLLAPSED;
    actions.uiTriggered({
      type,
    });
    this.setState({
      deliveredExpanded: !deliveredExpanded,
    });
  };

  /**
   * Reports to analytics and flips expanded state
   * @returns {void} void
   * @memberof TrucksExpandableSectionComponent
   */
  onExpansionInTransitPanelChange = () => {
    const { actions } = this.props;
    const { inTransitExpanded } = this.state;
    const type = !inTransitExpanded ? UI_IN_TRANSIT_EXPANSION_PANEL_EXPANDED : UI_IN_TRANSIT_EXPANSION_PANEL_COLLAPSED;
    actions.uiTriggered({
      type,
    });
    this.setState({
      inTransitExpanded: !inTransitExpanded,
    });
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<TrucksExpandableSectionComponent />`
   * @memberof TrucksExpandableSectionComponent
   */
  render() {
    const { currentDeliveryDetails, currentOrder, classes } = this.props;
    const { scheduledExpanded, deliveredExpanded, inTransitExpanded, docketId } = this.state;
    const { summary } = currentOrder || {};
    const { orderLine } = summary;
    const orderCode = summary.orderCode.trim();
    const unitOfMeasure = this.getUnitOfMeasure();

    if (!currentDeliveryDetails || !currentDeliveryDetails.data) {
      return null;
    }
    const {
      data: {
        orders: {
          loads: { scheduled, delivered, intransit },
          orderQty: totalOrdered,
          totalDelivered,
          totalIntransit,
          totalScheduled,
        },
      },
    } = currentDeliveryDetails;

    const sortedDelivered = orderBy(delivered, ['reviewedOnJobTime'],['asc']);
    const deliveredLoads = sortedDelivered.map(this.renderDeliveredLoad(1));
    const sortedInTransit = orderBy(intransit, ['reviewedOnJobTime'],['asc']);;
    const inTransitLoads = sortedInTransit.map(this.renderInTransitLoad(delivered.length + 1));
    const scheduledLoads = scheduled.map(this.renderScheduledLoad(intransit.length + delivered.length + 1));
    return (
      <React.Fragment>
        {docketId && (
          <DeliveryDocketModal
            currentDocket={{
              orderDate: currentOrder.orderKey.substring(0, 8),
              orderCode,
              orderLine,
              docketNumber: docketId,
            }}
            currentAccount={currentOrder && currentOrder.summary ? currentOrder.summary.customerCode : ''}
            onCloseDetails={this.closeDocketDetails}
            open={!!docketId}
          />
        )}
        <Typography variant="h6">Trucks</Typography>
        <Divider className={cn(classes.marginTop2unit, classes.marginBottom2unit)} />
        {this.renderPanel({
          loads: deliveredLoads,
          summary: `${round(totalDelivered, 1).toFixed(1)} / ${round(totalOrdered, 1).toFixed(1)} ${unitOfMeasure}`,
          totalOrdered,
          onExpansionPanelChange: this.onExpansionDeliveredPanelChange,
          expanded: deliveredExpanded,
          label: (
            <Typography variant="subtitle2" className={classes.dotDelivered}>
              Arrived
            </Typography>
          ),
        })}
        <Divider className={cn(classes.marginTop2unit, classes.marginBottom2unit)} />
        {this.renderPanel({
          loads: inTransitLoads,
          summary: `${round(totalIntransit, 1).toFixed(1)} ${unitOfMeasure}`,
          onExpansionPanelChange: this.onExpansionInTransitPanelChange,
          expanded: inTransitExpanded,
          label: (
            <Typography variant="subtitle2" className={classes.dotInTransit}>
              In Transit
            </Typography>
          ),
        })}
        <Divider className={cn(classes.marginTop2unit, classes.marginBottom2unit)} />
        {this.renderPanel({
          loads: scheduledLoads,
          summary: `${round(totalScheduled, 1).toFixed(1)} / ${round(totalOrdered, 1).toFixed(1)} ${unitOfMeasure}`,
          onExpansionPanelChange: this.onExpansionScheduledPanelChange,
          expanded: scheduledExpanded,
          label: (
            <Typography variant="subtitle2" className={classes.dotToGo}>
              To Go
            </Typography>
          ),
        })}
        <Divider className={cn(classes.marginTop2unit, classes.marginBottom2unit)} />
        {this.renderPlusLoad()}
      </React.Fragment>
    );
  }
}

/** @type {React.ComponentClass<TrucksExpandableSectionProps>} */
const TrucksExpandableSection = compose(
  withStyles(themeCreateInjectableStyles(TrucksExpandableSectionStyles), { withTheme: true }),
  connect(
    (state) => ({
      locale: i18nLocaleSelector(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(TrucksExpandableSectionComponent);

export default TrucksExpandableSection;
